import React, { Component } from 'react'
import './App.css'

import { Switch, Route } from 'react-router-dom'
import Landing from './Landing'
import Home from './Home'
import Book from './Main/Book'
import Testament from './Main/Testament'

import AudioPlayer from './AudioPlayer'

const App = (props) => (
  <div className="App">
    <Switch>
      <Route path='/' exact component={Landing} />
      <Route path='/bible' exact component={Home} />
      <Route path='/bible/old-testament' exact render={(routeProps) => <Testament testament='old' />} />
      <Route path='/bible/new-testament' exact render={(routeProps) => <Testament testament='new' />} />
      <Route path='/bible/:book/:chapter?' component={Book} />
    </Switch>
    <AudioPlayer />
  </div>
)

export default App



// WEBPACK FOOTER //
// ./src/components/App.js